export const PAGE_KEY = {
  OVERLAY_VISIBILITY: 'OverlayVisibility',
  SELECTED_APP: 'SelectedApp',
  SELECTED_CHANNEL: 'SelectedChannel',
  SELECTED_PROGRAM: 'SelectedProgram',
  SELECTED_VOD: 'SelectedVOD',
  TRACK_MENU_OVERRIDE: 'TrackMenuOverride',
}
